import './ProjectDetailsImagesList.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_PaginationProps } from '../../../../../../design/pagination/S_Pagination';
import { ColumnLayout } from '../../../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { RowLayout } from '../../../../../../modules/common/layouts/rowLayout/RowLayout';
import { SpaceBetweenLayout } from '../../../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { SortingDirection } from '../../../../../models/sortingDirection.model';
import { ListViewMode } from '../../../../user/user.store';
import { BatchAnswerQuestionsContainer } from '../containers/BatchAnswerQuestions.container';
import { FilteredImagesCounterContainer } from '../containers/filters/FilteredImagesCounter.container';
import { ImageFiltersContainer } from '../containers/filters/ImageFilters.container';
import { ProjectDetailsImageSetTypeContainer } from '../containers/ProjectDetailsImageSetType.container';
import { SelectAllButtonContainer } from '../containers/SelectAllButton.container';
import { SelectedImagesCounterContainer } from '../containers/SelectedImagesCounter.container';
import { SortingBy } from '../imageFilters.model';
import { ImageSelectionMode, ImageSetType, IProjectDetailsImage } from '../projectDetailsImages.model';
import { ProjectDetailsImagesListTable } from './ProjectDetailsImagesListTable';
import { ProjectDetailsImagesListThumbs } from './ProjectDetailsImagesListThumbs';

library.add(faUnlink, faEdit);

export interface IProjectDetailsImagesListProps {
  workspaceId: string;
  projectId: string;
  filterId: string;
  detailsImages: ReadonlyArray<IProjectDetailsImage>;
  isLoading: boolean;
  pagination: S_PaginationProps;
  viewMode: ListViewMode;
  authToken: string;
  selectionMode: ImageSelectionMode;
  toggledImages: string[];
  orderBy: string;
  orderType: string;
  onOrderingChange: (by: SortingBy, direction: SortingDirection | undefined) => Promise<void>;
  onCheck: (id: string, isBatch: boolean) => void;
  onCheckAll: () => void;
  onImageSetChange: (id: string, type: ImageSetType) => Promise<void>;
}

export const ProjectDetailsImagesList = observer((props: IProjectDetailsImagesListProps): ReactElement => {
  return (
    <ColumnLayout
      size='md'
      className='project-details-images-list'
    >
      <ColumnLayout
        size='md'
        className='controls'
      >
        <SpaceBetweenLayout className='image-filters'>
          <ImageFiltersContainer />
          <RowLayout size='md'>
            <BatchAnswerQuestionsContainer />
            <SelectAllButtonContainer />
            <ProjectDetailsImageSetTypeContainer />
          </RowLayout>
        </SpaceBetweenLayout>
        <SpaceBetweenLayout className='image-counters'>
          <FilteredImagesCounterContainer />
          <SelectedImagesCounterContainer />
        </SpaceBetweenLayout>
      </ColumnLayout>
      <ColumnLayout
        size='md'
        className='project-details-container'
      >
        {props.viewMode === ListViewMode.List && <ProjectDetailsImagesListTable {...props} />}
        {props.viewMode === ListViewMode.Tiles && <ProjectDetailsImagesListThumbs {...props} />}
      </ColumnLayout>
    </ColumnLayout>
  );
});
